import { TrackingHistoryItemProps } from "../TrackingHistoryItem/TrackingHistoryItem";
import { LineIconType, LineType } from "./trackingHistoryTypes";

/**
 * Get the type of line for the TrackingHistoryItem to be displayed a TrackingHistoryItem.
 *
 * @param index - index of the TrackingHistoryItem that is being rendered
 * @param history - array of HistoryItem objects
 * @returns {LineType} - the type of line for the TrackingHistoryItem
 */
export const getLineType = (index: number, history: TrackingHistoryItemProps[]): LineType => {
  const isCompleted = new Date(history[index].date) < new Date() && !history[index]?.isEstimatedDate;
  const isNextHistoryItemCompleted =
    index < history.length - 1 && new Date(history[index + 1].date) < new Date() && !history[index + 1]?.isEstimatedDate;

  if (!isNextHistoryItemCompleted && isCompleted) return "upcoming";
  if (isCompleted) return "completed";
  return "incompleted";
};

/**
 * Get the type of icon for the line for the TrackingHistoryItem.
 *
 * @param index - index of the TrackingHistoryItem that is being rendered
 * @param history - array of HistoryItem objects
 * @returns {LineIconType} - the type of icon for the line for the TrackingHistoryItem
 */
export const getLineIconType = (index: number, history: TrackingHistoryItemProps[]): LineIconType => {
  const isCompleted = new Date(history[index].date) < new Date() && !history[index]?.isEstimatedDate;
  const isPrevHistoryItemCompleted =
    index > 0 ? new Date(history[index - 1].date) < new Date() : true && !history[index - 1]?.isEstimatedDate;
  const isNextHistoryItemCompleted =
    index < history.length - 1 && new Date(history[index + 1].date) < new Date() && !history[index + 1]?.isEstimatedDate;

  if (isPrevHistoryItemCompleted && !isNextHistoryItemCompleted && isCompleted) return "latestCompleted";
  if (isCompleted) return "completed";
  return "incompleted";
};
